import React from "react";
import { Info } from "lucide-react"; // Using lucide-react for a modern 'i' icon

const Tooltip = ({ text, position = "top" }) => {
  return (
    <div className="relative flex items-center group">
      <Info className="w-4 h-4 text-gray-400 hover:text-gray-200 cursor-pointer" />
      <div
        className={`absolute left-1/2 bottom-full mb-2 -translate-x-1/2 w-[250px] bg-gray-800 text-white text-xs p-2 rounded-md shadow-lg opacity-0 scale-95 group-hover:opacity-100 group-hover:scale-100 transition-all duration-200 z-50`}
      >
        {text}
      </div>
    </div>
  );
};

export default Tooltip;
